module.exports = __webpack_public_path__ + "static/media/Buizel_gaussian2.ac4a681a.png";